import React from 'react';
import { T } from 'Actions/translate';

class OrderRemark extends React.Component {
    render() {
        let { className, remark } = this.props;

        if(!remark) return null;

        return(
            <div className={ className }>
                <label>{T('order_remark_colon')} </label>
                <p>{ remark }</p>
            </div>
        );
    }
}

export default OrderRemark;
